import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { dmy } from "./kpiFormat";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromIso = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

/** Picks a reporting-week start (Saturday). */
export const WeekStartPicker = ({ value, onChange, disabled, testId, placeholder = "Pick a Saturday", clearable }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex items-center gap-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" disabled={disabled} className="h-9 w-48 justify-start font-mono-num font-normal" data-testid={testId}>
            <CalendarDays className="h-4 w-4 mr-2 text-zinc-500" />
            {value ? `Sat ${dmy(value, true)}` : <span className="text-zinc-400">{placeholder}</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" weekStartsOn={6} selected={fromIso(value)} defaultMonth={fromIso(value)}
            disabled={(d) => d.getDay() !== 6} onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }}
            data-testid={`${testId}-calendar`} />
        </PopoverContent>
      </Popover>
      {clearable && value && !disabled && (
        <button type="button" className="text-xs text-zinc-500 hover:text-zinc-900" onClick={() => onChange(null)}
          data-testid={`${testId}-clear`}>Clear</button>
      )}
    </div>
  );
};
